/**
 * Who a parent can invite to their own athlete login (#5413 U9). 13-17 get a
 * supervised teen login. 18+ get their own login so they can sign their own
 * waivers; the parent keeps paying. The database rule is
 * can_parent_invite_athlete, which also allows 18+ only for the paying parent.
 */

export const ATHLETE_INVITATION_MIN_AGE = 13;
export const ADULT_ATHLETE_AGE = 18;

export function isInvitableAthleteAge(age: number): boolean {
  return Number.isFinite(age) && age >= ATHLETE_INVITATION_MIN_AGE;
}

export function isAdultAthleteAge(age: number): boolean {
  return Number.isFinite(age) && age >= ADULT_ATHLETE_AGE;
}
